import { gql, TypedDocumentNode } from "@apollo/client";

import {
  PendingWritingCompanionProposalsQuery,
  PendingWritingCompanionProposalsQueryVariables,
} from "./PendingWritingCompanionProposals.generated";

const PENDING_WRITING_COMPANION_PROPOSALS: TypedDocumentNode<
  PendingWritingCompanionProposalsQuery,
  PendingWritingCompanionProposalsQueryVariables
> = gql`
  query PendingWritingCompanionProposals($noteUuid: String!) {
    pendingWritingCompanionProposals(noteUuid: $noteUuid) {
      uuid
      noteUuid
      noteSection
      afterContent
      createdAt
    }
  }
`;

export default PENDING_WRITING_COMPANION_PROPOSALS;
